import { Button, Drawer, MenuItem } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import React, { useState } from 'react';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../../layouts/property/propertySlice';
import { Menu } from '@mui/material';
import DeletePopupModel from '../../../shared/delete-popup/Delete-Popup';
import GuestRoomExperienceRoomTabDoorLockEdit from './Guest-Room-Experience-Room-Tab-Door-Lock-Edit';
import { GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK_EDIT } from '../../../constants/GuestRoomExperienceConst';

const GuestRoomExperienceRoomTabDoorLock = (props) => {
  const { doorLockInfo, roomId, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const [editState, setEditState] = useState({
    type: '',
    status: false,
    obj: null,
  });

  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });

  const handleItemClick = (event) => {
    setSelectedValue({
      id: 'dummy id',
      name: 'dummy name',
      title: '',
      description: '',
      status: false,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      item: null,
    });
  };

  const deleteDoorLockData = async () => {
    handleClose();
  };

  const handleDeletePopupOpen = (e) => {
    e.preventDefault();
    setSelectedValue({
      id: 'dummy id',
      name: 'dummy name',
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed.',
      status: true,
      anchorEl: null,
    });
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
    });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setEditState({
      type: GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK_EDIT,
      status: open,
      obj: null,
    });
  };

  const onDrawerToggle = (type, status, obj) => {
    setEditState({
      type: type,
      status: status,
      obj: obj,
    });
    handleClose();
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteDoorLockData}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {editState.status && (
        <Drawer
          anchor={'right'}
          open={editState.status}
          onClose={toggleDrawer(false)}
          className='right-drawer'
        >
          <GuestRoomExperienceRoomTabDoorLockEdit
            doorLockInfo={doorLockInfo}
            roomId={roomId}
            selectedHotel={selectedHotel}
            toggleDrawer={onDrawerToggle}
            showLoader={showLoader}
          />
        </Drawer>
      )}
      <div className='col-md-12'>
        <div className='row room-area-content px-3 mt-2'>
          <div className='row content-row'>
            <div className='col-md-7 d-flex'>
              <span className='content content-label me-2'>Door Lock Name :</span>
              <span className='content content-value'>{doorLockInfo.name}</span>
            </div>
            <div className='col-md-4 d-flex'>
              <span className='content status-label  me-3'>Status:</span>
              <span>
                <div className='d-flex justify-content-center'>
                  <div
                    className={`${
                      doorLockInfo?.status === 'online'
                        ? 'pill-online'
                        : doorLockInfo?.status === 'pending'
                        ? ' pill-pending'
                        : doorLockInfo?.status === 'error'
                        ? 'pill-error'
                        : 'pill-unassigned'
                    } 
                       pill d-flex justify-content-center align-items-center`}
                  >
                    <span className='ms-1'>
                      {doorLockInfo?.status === 'pending'
                        ? 'Pending'
                        : doorLockInfo?.status === 'online'
                        ? 'Online'
                        : doorLockInfo?.status === 'error'
                        ? 'Error'
                        : 'Offline'}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className='col-md-1 d-flex justify-content-end'>
              <Button
                aria-controls='simple-menu'
                aria-haspopup='true'
                onClick={(e) => {
                  handleItemClick(e);
                }}
              >
                <MoreHoriz />
              </Button>
              <Menu
                anchorEl={selectedValue?.anchorEl}
                disableRestoreFocus
                MenuListProps={{ autoFocusItem: false }}
                keepMounted
                open={Boolean(selectedValue.anchorEl)}
                onClose={handleClose}
                className='shadow'
              >
                <MenuItem
                  className='pe-4'
                  onClick={(e) => {
                    onDrawerToggle(
                      GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK_EDIT,
                      true,
                      doorLockInfo,
                    );
                  }}
                >
                  <CreateIcon className='me-2 action-menu-icon' />
                  Edit
                </MenuItem>
                <MenuItem
                  className='pe-4'
                  onClick={(e) => {
                    handleDeletePopupOpen(e);
                  }}
                >
                  <DeleteForeverIcon className='me-2 action-menu-icon' />
                  Delete
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestRoomExperienceRoomTabDoorLock;
